import a from "react";
import { Home as d, Search as N, PlusCircle as x, MessageCircle as E, Menu as u } from "@olxbr/ds-icons";
import { cls as r } from "../../helpers/cls.js";
import { Link as s } from "../Link/Link.js";
import { Text as o } from "../Text/Text.js";
import { sendClickEvent as l } from "./utils/sendClickEvent.js";
import { OnboardingTooltip as f } from "../Header/components/OnboardingTooltip/OnboardingTooltip.js";
var g = Object.defineProperty,
  w = Object.defineProperties,
  h = Object.getOwnPropertyDescriptors,
  m = Object.getOwnPropertySymbols,
  C = Object.prototype.hasOwnProperty,
  k = Object.prototype.propertyIsEnumerable,
  b = (e, t, n) => t in e ? g(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[t] = n,
  O = (e, t) => {
    for (var n in t || (t = {})) C.call(t, n) && b(e, n, t[n]);
    if (m) for (var n of m(t)) k.call(t, n) && b(e, n, t[n]);
    return e;
  },
  y = (e, t) => w(e, h(t));
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const v = _ref => {
  let {
    pageActive: e,
    onClickAccount: t,
    isLogged: n,
    chatNotification: i,
    onboardingOpen: _,
    onboardingCloseCallback: p
  } = _ref;
  const c = {
    login: n
  };
  return a.createElement("nav", {
    className: "olx-navbar",
    "aria-label": "Menu secund\xE1rio",
    "data-ds-component": "DS-Navbar",
    "data-open": e.account
  }, a.createElement("ul", {
    className: "olx-navbar__items"
  }, a.createElement("li", {
    className: "olx-navbar__item"
  }, a.createElement(s, {
    dsParentName: "Navbar",
    "data-dd-action-name": "In\xEDcio",
    variant: "grey",
    href: "https://www.olx.com.br",
    className: "olx-navbar__link",
    onClick: () => l("home", c)
  }, a.createElement(d, {
    className: e.home ? "olx-navbar--active" : ""
  }), a.createElement(o.Caption, {
    className: r("olx-navbar__caption", e.home && "olx-navbar--active")
  }, "In\xEDcio"))), a.createElement("li", {
    className: "olx-navbar__item"
  }, a.createElement(s, {
    dsParentName: "Navbar",
    "data-dd-action-name": "Buscar",
    variant: "grey",
    href: "https://www.olx.com.br/brasil",
    className: "olx-navbar__link",
    onClick: () => l("buscar", c)
  }, a.createElement(N, {
    className: e.search ? "olx-navbar--active" : ""
  }), a.createElement(o.Caption, {
    className: r("olx-navbar__caption", e.search && "olx-navbar--active")
  }, "Buscar"))), a.createElement("li", {
    className: "olx-navbar__item"
  }, a.createElement(s, {
    dsParentName: "Navbar",
    "data-dd-action-name": "Anunciar",
    variant: "grey",
    href: "https://www2.olx.com.br/desapega",
    className: "olx-navbar__link",
    onClick: () => l("ad_insert", c)
  }, a.createElement(x, {
    className: e.announce ? "olx-navbar--active" : ""
  }), a.createElement(o.Caption, {
    className: r("olx-navbar__caption", e.announce && "olx-navbar--active")
  }, "Anunciar"))), a.createElement("li", {
    className: "olx-navbar__item"
  }, a.createElement(s, {
    dsParentName: "Navbar",
    "data-dd-action-name": "Mensagens",
    variant: "grey",
    href: "https://conta.olx.com.br/chats",
    className: "olx-navbar__link",
    onClick: () => l("chat", y(O({}, c), {
      chatNotification: i
    }))
  }, a.createElement("span", {
    className: "olx-navbar__icon-wrapper"
  }, a.createElement("span", {
    className: "olx-navbar__notification-wrapper",
    "data-counter": i && i > 9 ? "+9" : i
  }, a.createElement(E, {
    className: "".concat(e.message ? "olx-navbar--active" : "")
  }))), a.createElement(o.Caption, {
    className: r("olx-navbar__caption", e.message && "olx-navbar--active")
  }, "Mensagem"))), a.createElement("li", {
    className: "olx-navbar__item"
  }, a.createElement(f, {
    className: "olx-header__onboarding-tooltip--navbar",
    open: !!_,
    closeCallback: p,
    placement: "top-end"
  }, a.createElement("button", {
    "data-ds-component": "DS-Navbar-Button",
    "data-dd-action-name": "Open menu",
    className: r("olx-navbar__link", e.account && "olx-navbar__button--active"),
    onClick: () => {
      t && t(), l("menu", c);
    }
  }, a.createElement(u, {
    className: e.account ? "olx-navbar--active" : ""
  }), a.createElement(o.Caption, {
    className: r("olx-navbar__caption", e.account && "olx-navbar--active")
  }, "Menu"))))));
};
v.displayName = "Navbar";
export { v as Navbar };